/**
 * Tour guide — Visite générale du portail
 */

const portalTour = [
  {
    target: '[data-testid="sidebar"]',
    title: 'Bienvenue sur le portail METERIS',
    content: 'La sidebar à gauche est votre menu principal. Elle regroupe toutes les sections du portail : ticketing, parc informatique, clients et utilisateurs, base de connaissances, outils et plus encore.',
    position: 'right',
  },
  {
    target: '[data-testid="sidebar-cat-ticketing"]',
    title: 'Ticketing',
    content: 'Gérez les tickets d\'assistance : créez, suivez et résolvez les demandes clients. Vue liste ou kanban avec glisser-déposer.',
    position: 'right',
    permission: 'ticketing.view',
  },
  {
    target: '[data-testid="sidebar-cat-parc"]',
    title: 'Parc informatique',
    content: 'Supervisez les ordinateurs, la prise en main à distance (MeterisConnect), les sauvegardes (Acronis) et les liaisons entre appareils.',
    position: 'right',
    permission: 'parc.view',
  },
  {
    target: '[data-testid="sidebar-cat-assistant"]',
    title: 'Assistant Telegram',
    content: 'Envoyez des messages vocaux ou texte au bot Telegram. Il classe automatiquement vos informations en prospects, idées, rendez-vous ou notes.',
    position: 'right',
    permission: 'assistant.view',
  },
  {
    target: '[data-testid="sidebar-cat-securite"]',
    title: 'Coffre-fort',
    content: 'Stockez les mots de passe et clés API des clients de manière sécurisée. Tout est chiffré en AES-256 avec des niveaux de sensibilité configurables.',
    position: 'right',
    permission: 'vault.view',
  },
  {
    target: '[data-tour="global-search"]',
    title: 'Recherche unifiée',
    content: 'Tapez Ctrl+K ou cliquez ici pour rechercher en même temps dans les menus, les tickets, les utilisateurs, les sociétés, les postes du parc et les articles de la base de connaissances. Naviguez dans les résultats avec les flèches du clavier et validez avec Entrée.',
    position: 'bottom',
  },
  {
    target: '[data-testid="notification-bell"]',
    title: 'Notifications',
    content: 'La cloche affiche vos alertes. Cliquez « Voir toutes les notifications » pour ouvrir le centre de notifications : tri, sélection multiple, « Reporter à demain 8 h » et « Ignorer » en masse (les critiques se traitent une par une).',
    position: 'bottom',
  },
  {
    target: '[data-tour="entity-selector"]',
    title: 'Filtre par société',
    content: 'Sélectionnez une société pour filtrer toutes les données du portail (tickets, parc, documents…) sur ce seul client. Utile quand vous travaillez sur un dossier spécifique.',
    position: 'bottom',
  },
  {
    target: '[data-testid="user-preferences-button"]',
    title: 'Vos préférences',
    content: 'Personnalisez votre interface : réordonnez les menus, renommez les sections, choisissez entre vue liste ou kanban pour les tickets.',
    position: 'right',
  },
  {
    target: '[data-testid="sidebar-toggle"]',
    title: 'Replier la sidebar',
    content: 'Cliquez ici pour replier la sidebar en mode icônes. Plus d\'espace pour travailler, mêmes fonctionnalités.',
    position: 'right',
  },
  {
    target: null,
    title: 'C\'est parti !',
    content: 'Vous connaissez maintenant les bases du portail METERIS. Le bouton ? (en bas à droite) vous donne l\'aide de chaque page. Bonne navigation !',
    position: 'bottom',
  },
];

export default portalTour;
